"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Popover_1 = require("../Popover");
var TooltipPopover_1 = require("./TooltipPopover");
var context_1 = require("./context");
function addEventListener(target, eventType, callback) {
    if (target.addEventListener) {
        target.addEventListener(eventType, callback, true);
        return function remove() {
            target.removeEventListener(eventType, callback, true);
        };
    }
    return null;
}
var DEFAULT_DELAY_TIMEOUT = 300;
var DEFAULT_CURSOR_RECT = {
    width: 12,
    height: 20
};
exports.useTooltip = function (_a) {
    var text = _a.text, title = _a.title, iconSrc = _a.iconSrc, icon = _a.icon, renderContent = _a.renderContent, maxWidth = _a.maxWidth, _b = _a.isActive, isActive = _b === void 0 ? true : _b, render = _a.render, delayTimeout = _a.delayTimeout, tooltipOffset = _a.tooltipOffset, style = _a.style, rest = __rest(_a, ["text", "title", "iconSrc", "icon", "renderContent", "maxWidth", "isActive", "render", "delayTimeout", "tooltipOffset", "style"]);
    var mouseMoveRemoveListener = react_1.useRef(null);
    var mouseDownRemoveListener = react_1.useRef(null);
    var showTimeout = react_1.useRef(null);
    var mousePositionRef = react_1.useRef(null);
    var shownPositionRef = react_1.useRef(null);
    var controlRef = react_1.useRef(null);
    var _c = react_1.useState(false), isShown = _c[0], setShownStatus = _c[1];
    var shownStateRef = react_1.useRef(false);
    var tooltipContext = react_1.useContext(context_1.TooltipContext);
    var hideTooltip = react_1.useState({
        current: function () {
            var _a;
            if (((_a = tooltipContext.current) === null || _a === void 0 ? void 0 : _a.hide) === hideTooltip.current) {
                tooltipContext.current = null;
            }
            if (showTimeout.current) {
                clearTimeout(showTimeout.current);
            }
            if (mouseMoveRemoveListener.current) {
                mouseMoveRemoveListener.current();
            }
            if (shownStateRef.current) {
                setShownStatus(false);
            }
            shownStateRef.current = false;
            shownPositionRef.current = null;
        }
    })[0];
    var showTooltip = function () {
        var _a;
        (_a = tooltipContext.current) === null || _a === void 0 ? void 0 : _a.hide();
        tooltipContext.current = { hide: hideTooltip.current };
        setShownStatus(true);
        shownStateRef.current = true;
    };
    react_1.useEffect(function () {
        return function () {
            if (showTimeout.current) {
                clearTimeout(showTimeout.current);
            }
            if (mouseMoveRemoveListener.current) {
                mouseMoveRemoveListener.current();
            }
            if (mouseDownRemoveListener.current) {
                mouseDownRemoveListener.current();
            }
        };
    }, []);
    react_1.useEffect(function () {
        if (!isActive) {
            if (mouseMoveRemoveListener.current) {
                mouseMoveRemoveListener.current();
            }
            if (mouseDownRemoveListener.current) {
                mouseDownRemoveListener.current();
            }
            if (showTimeout.current) {
                clearTimeout(showTimeout.current);
            }
            shownPositionRef.current = null;
            if (shownStateRef.current) {
                hideTooltip.current();
            }
        }
    }, [isActive]);
    var popover = Popover_1.usePopover({
        config: [
            { xAxis: Popover_1.X_AXIS.outsideRight, yAxis: Popover_1.Y_AXIS.outsideBottom, offsetY: 0 },
            { xAxis: Popover_1.X_AXIS.middle, yAxis: Popover_1.Y_AXIS.outsideBottom, offsetY: 0 },
            { xAxis: Popover_1.X_AXIS.insideRight, yAxis: Popover_1.Y_AXIS.outsideBottom, offsetY: 0 },
            { xAxis: Popover_1.X_AXIS.outsideRight, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: -6 },
            { xAxis: Popover_1.X_AXIS.middle, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: -6 },
            { xAxis: Popover_1.X_AXIS.insideRight, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: -6 }
        ],
        target: {
            measure: function () {
                if (!shownPositionRef.current) {
                    return null;
                }
                var _a = shownPositionRef.current, x = _a.x, y = _a.y;
                var cursor = tooltipOffset || DEFAULT_CURSOR_RECT;
                return __assign({ top: y, left: x }, cursor);
            }
        },
        render: function (ref) {
            return react_1.default.createElement(TooltipPopover_1.TooltipPopover, {
                ref: ref,
                text: text,
                title: title,
                iconSrc: iconSrc,
                icon: icon,
                renderContent: renderContent,
                maxWidth: maxWidth,
                style: style,
                'data-selector-id': rest['data-selector-id'] || 'tooltip'
            });
        }
    });
    var onMouseEnter = function () {
        if (!isActive) {
            return;
        }
        if (showTimeout.current) {
            clearTimeout(showTimeout.current);
        }
        var delay = delayTimeout || DEFAULT_DELAY_TIMEOUT;
        var timeoutCallback = function () {
            showTimeout.current = null;
            if (mouseDownRemoveListener.current) {
                mouseDownRemoveListener.current();
            }
            if (mousePositionRef.current) {
                shownPositionRef.current = mousePositionRef.current;
                showTooltip();
            }
        };
        mouseMoveRemoveListener.current = addEventListener(window, 'mousemove', function (e) {
            mousePositionRef.current = { x: e.clientX, y: e.clientY };
        });
        showTimeout.current = window.setTimeout(timeoutCallback, delay);
    };
    var onMouseLeave = function () {
        if (!isActive) {
            return;
        }
        if (mouseMoveRemoveListener.current) {
            mouseMoveRemoveListener.current();
        }
        if (mouseDownRemoveListener.current) {
            mouseDownRemoveListener.current();
        }
        hideTooltip.current();
    };
    var onMouseDown = function () {
        hideTooltip.current();
    };
    return react_1.default.createElement(react_1.default.Fragment, null, render({ ref: controlRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown }), isActive && isShown && popover);
};
//# sourceMappingURL=hooks.js.map